import React from 'react';
import styled from 'styled-components';

import { AlertWarning } from '@ad-scripts/presentation/components/common/alert';
import FieldContainer from 'src/presentation/components/forms/FieldContainer';
import ExternalLink from 'src/presentation/components/pages/shared/ExternalLink';
import InputField from 'src/presentation/components/forms/InputField';
import InsetContainer from '@ad-scripts/presentation/components/common/containers/inset_container';
import InternationalPhoneIcon from '@ad-scripts/presentation/components/common/icons/stroke/international-phone-stroke';

type PhoneNumberTemplate = {
  attr: string;
  description: string;
  label: string;
  'data-aid': string;
};

const PhoneNumberTemplate = ({ attr, description, label, 'data-aid': dataAid }: PhoneNumberTemplate): JSX.Element => {
  const control = (
    <PhoneNumberTemplateContainer>
      <InputContainer>
        <StyledInternationalPhoneIcon />
        <InputField attr={attr} disabled={true} data-aid={`${dataAid}-template`} />
      </InputContainer>
      <StyledAlertWarning className="alertWarning">
        <b>Note:</b> This phone number is a variable. To edit this value,{' '}
        <StyledExternalLink
          className="learnWhyHelpLink"
          data-aid="learn-why-help-link"
          label="contact Support"
          to="https://help.gladly.com/docs/contact-gladly-support"
        />
        .
      </StyledAlertWarning>
    </PhoneNumberTemplateContainer>
  );

  return <FieldContainer label={label} description={description} control={control} />;
};

const StyledExternalLink = styled(ExternalLink)`
  text-decoration: underline;
  color: ${p => p.theme.colors.black};

  &:hover {
    text-decoration: underline;
  }
`;

const StyledAlertWarning = styled(AlertWarning)`
  line-height: ${p => p.theme.lineHeight.base};

  svg {
    margin-top: ${p => p.theme.spacing.small};
  }
`;

const PhoneNumberTemplateContainer = styled(InsetContainer).attrs({ inset: 'none' })`
  width: 100%;
`;

const InputContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  margin-bottom: 12px;
`;

const StyledInternationalPhoneIcon = styled(InternationalPhoneIcon)`
  height: ${p => p.theme.fontSize.base};
  margin-right: 8px;
  width: auto;
`;

export default PhoneNumberTemplate;
